export const actionHinderanceEffects = {
  stun: {
    primitives: ['immobile', 'disablePartSkills', 'disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_stun'
      }
    }
  },
  sleep: {
    primitives: ['immobile', 'disablePartSkills', 'disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_sleep'
      }
    }
  },
  root: {
    primitives: ['immobile'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_root'
      }
    }
  },
  slow: {
    primitives: ['scaleMoveSpeed'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_slow'
      }
    }
  },
  silence: {
    primitives: ['disablePartSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_silence'
      }
    }
  },
  disarm: {
    primitives: ['disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_disarm'
      }
    }
  },
  hex: {
    primitives: ['scaleMoveSpeed', 'disablePartSkills', 'disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_hex'
      }
    }
  },
  fear: {
    primitives: ['forceFromPoint', 'disablePartSkills', 'disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_fear'
      }
    }
  },
  taunt: {
    primitives: ['forcedCoreSkill', 'disablePartSkills', 'scaleCastRange'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_taunt'
      }
    }
  },
  lure: {
    primitives: ['forceToEntity', 'disablePartSkills', 'disableCoreSkills'],
    resources: {
      icon: {
        type: 'multiAtlas',
        datasetKey: 'ui_mobile',
        stateUsage: 'status_taunt'
      }
    }
  }
} as const;
